/**
 * Fit Finder — standalone landing page quiz.
 * Pair with templates/page.fit-finder.liquid + assets/fit-finder.css + fit-finder-page.css.
 */
(function () {
  const SIZE_ORDER = ['XS', 'S', 'M', 'M/L', 'L', 'XL'];

function sizeFromChest(chest) {
  const c = parseFloat(chest);
  if (!c) return null;
  if (c <= 34) return 'XS';
  if (c <= 37) return 'S';
  if (c <= 40) return 'M';
  if (c <= 42) return 'M/L';   // fixed: was "c < 42"
  if (c <= 44) return 'L';
  return 'XL';
}

  function sizeFromWeight(weight) {
    const w = parseInt(weight, 10);
    if (!w) return 'M';
    if (w <= 130) return 'XS';
    if (w <= 145) return 'S';
    if (w <= 160) return 'M';
    if (w <= 185) return 'M/L';
    if (w <= 200) return 'L';
    return 'XL';
  }

  const SHAPE_DELTA = { narrower: -1, flatter: -1, average: 0, broader: 1, rounder: 1 };

  const RESULT_COPY = {
    slim: (s) => `A size ${s} sized down for a closer, tailored line through the body.`,
    regular: (s) => `A size ${s} true to size — clean through the body with proper sleeve and body length.`,
    relaxed: (s) => `A size ${s} sized up for a roomier, more relaxed drape.`
  };

  class FitFinderPage {
    constructor(root) {
      this.root = root;
      this.state = {
        step: 1, feet: 5, inches: 7, weight: 160, chest: '',
        chestShape: 'average', stomachShape: 'average', fit: 'regular'
      };
      this.bind();
    }

    bind() {
      const root = this.root;

      root.querySelectorAll('.fit-finder-stepper').forEach((stepper) => {
        const key = stepper.dataset.stepper;
        const min = parseInt(stepper.dataset.min, 10);
        const max = parseInt(stepper.dataset.max, 10);
        const step = parseInt(stepper.dataset.step || '1', 10);
        stepper.querySelector('[data-dec]').addEventListener('click', () => {
          this.state[key] = Math.max(min, this.state[key] - step);
          this.renderStepper(stepper, this.state[key]);
        });
        stepper.querySelector('[data-inc]').addEventListener('click', () => {
          this.state[key] = Math.min(max, this.state[key] + step);
          this.renderStepper(stepper, this.state[key]);
        });
      });

      const chestInput = root.querySelector('[data-chest-input]');
      if (chestInput) {
        chestInput.addEventListener('input', (e) => { this.state.chest = e.target.value; });
      }

      root.querySelectorAll('[data-choice-group]').forEach((group) => {
        const key = group.dataset.choiceGroup;
        group.querySelectorAll('[data-value]').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.state[key] = btn.dataset.value;
            group.querySelectorAll('[data-value]').forEach((b) => b.removeAttribute('data-selected'));
            btn.setAttribute('data-selected', '');
          });
        });
      });

      root.querySelectorAll('[data-next]').forEach((btn) =>
        btn.addEventListener('click', () => this.goStep(this.state.step + 1))
      );
      root.querySelectorAll('[data-back]').forEach((btn) =>
        btn.addEventListener('click', () => this.goStep(this.state.step - 1))
      );

      const resultBtn = root.querySelector('[data-result]');
      if (resultBtn) {
        resultBtn.addEventListener('click', () => {
          this.computeResult();
          this.goStep(6);
        });
      }

      const restartBtn = root.querySelector('[data-restart]');
      if (restartBtn) restartBtn.addEventListener('click', () => this.reset());

      root.querySelectorAll('[data-ff-add-btn]').forEach((btn) => {
        btn.addEventListener('click', () => this.addToCart(btn));
      });
    }

    renderStepper(stepper, value) {
      stepper.querySelector('[data-value]').textContent = value;
    }

    goStep(n) {
      if (n < 1 || n > 6) return;
      this.state.step = n;
      this.root.querySelectorAll('.fit-finder-step').forEach((el) => {
        el.hidden = parseInt(el.dataset.step, 10) !== n;
      });
      const label = this.root.querySelector('[data-ff-step-label]');
      if (label) label.textContent = `Step ${n} of 6`;
    }

    computeResult() {
      const { chest, weight, chestShape, stomachShape, fit } = this.state;
      const chestSize = sizeFromChest(chest);
      const baseSize = chestSize || sizeFromWeight(weight);
      let idx = SIZE_ORDER.indexOf(baseSize);

      const shapeSum = (SHAPE_DELTA[chestShape] || 0) + (SHAPE_DELTA[stomachShape] || 0);
      const netShape = shapeSum >= 2 ? 1 : shapeSum <= -2 ? -1 : 0;
      idx = Math.min(SIZE_ORDER.length - 1, Math.max(0, idx + netShape));

      if (fit === 'slim' && idx > 0) idx -= 1;
      if (fit === 'relaxed' && idx < SIZE_ORDER.length - 1) idx += 1;

      this.resultSize = SIZE_ORDER[idx];
      this.root.querySelector('[data-result-size]').textContent = this.resultSize;
      this.root.querySelector('[data-result-copy]').textContent = RESULT_COPY[fit](this.resultSize);
      this.annotateProductCards();
    }

    annotateProductCards() {
      this.root.querySelectorAll('[data-ff-product-card]').forEach((card) => {
        const variantsScript = card.querySelector('[data-ff-product-variants]');
        const note = card.querySelector('[data-ff-note]');
        if (!variantsScript || !note) return;
        const variants = JSON.parse(variantsScript.textContent || '[]');
        const match = variants.find((v) => v.size === this.resultSize);
        if (match && match.available) {
          note.textContent = `Your size (${this.resultSize}) is in stock`;
          note.hidden = false;
        } else if (match) {
          note.textContent = `Your size (${this.resultSize}) is currently out of stock`;
          note.hidden = false;
        } else {
          note.hidden = true;
        }
      });
    }

    addToCart(btn) {
      const card = btn.closest('[data-ff-product-card]');
      const variantsScript = card.querySelector('[data-ff-product-variants]');
      const variants = JSON.parse(variantsScript.textContent || '[]');
      const size = this.resultSize;
      const match = size && variants.find((v) => v.size === size && v.available);
      const variantId = match ? match.id : (variants.find((v) => v.available) || {}).id;
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then((r) => r.json())
        .then(() => { document.dispatchEvent(new CustomEvent('cart:refresh')); })
        .catch((err) => console.error('Fit Finder: add to cart failed', err));
    }

    reset() {
      this.state = {
        step: 1, feet: 5, inches: 7, weight: 160, chest: '',
        chestShape: 'average', stomachShape: 'average', fit: 'regular'
      };
      const chestInput = this.root.querySelector('[data-chest-input]');
      if (chestInput) chestInput.value = '';
      this.root.querySelectorAll('.fit-finder-stepper').forEach((s) =>
        this.renderStepper(s, this.state[s.dataset.stepper])
      );
      this.root.querySelectorAll('[data-choice-group]').forEach((group) => {
        group.querySelectorAll('[data-value]').forEach((b) => b.removeAttribute('data-selected'));
        group.querySelector('[data-value="average"], [data-value="regular"]')?.setAttribute('data-selected', '');
      });
      this.goStep(1);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.ff-page').forEach((root) => new FitFinderPage(root));
  });
})();